import React, { Fragment } from 'react';
import { useLocation, matchPath } from 'react-router-dom';

import MainSideBar from './Sidebar/MainSidebar';
import { isAppPagePath } from '../../functions/isAppPagePath';
import { isStaffListPath } from '../../functions/staffListPath';
import classes from './Layout.module.css';

const Layout = (props) => {
    const location = useLocation();

    const isRegistrationFlexMain =
        !!matchPath({ path: '/registration/:parentLoginId/registrations', end: true }, location.pathname) ||
        !!matchPath({ path: '/registration/:parentLoginId/registrations/:parentId', end: true }, location.pathname);

    return (
        <Fragment>
            {!isAppPagePath(location.pathname) && <MainSideBar/>}
            <main className={[
                isRegistrationFlexMain ? classes.mainFlexColumn : '',
                isStaffListPath(location.pathname) ? classes.mainStaffList : '',
            ].filter(Boolean).join(' ') || undefined}>{props.children}</main>
        </Fragment>
    );
};

export default Layout;
